import { createContext, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { IntlProvider } from 'react-intl'

import LOCALES from './locales'
import { DEFAULT_LOCALE, findMatchingLocale } from './intl'
import translations from './messages'

const STORAGE_KEY = 'ctt-clientes-locale'

const LocaleContext = createContext(null)

export const useLocale = () => useContext(LocaleContext)

const getInitialLocale = () => {
  const stored = window.localStorage.getItem(STORAGE_KEY)
  if (stored && LOCALES.some(({ locale }) => locale === stored)) return stored
  return findMatchingLocale()
}

const LocaleProvider = ({ children }) => {
  const [locale, setLocaleState] = useState(getInitialLocale)

  const setLocale = newLocale => {
    window.localStorage.setItem(STORAGE_KEY, newLocale)
    setLocaleState(newLocale)
  }

  const value = useMemo(() => ({ locale, setLocale }), [locale])
  const messages = translations[locale] || translations[DEFAULT_LOCALE]

  return (
    <LocaleContext.Provider value={value}>
      <IntlProvider locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  )
}

LocaleProvider.propTypes = {
  children: PropTypes.node,
}

export default LocaleProvider
